module.exports = "images/directs.3adbcf3f.png";